module.exports = {"230904001":"东风街道","230904002":"向阳街道","230904003":"富强街道","230904004":"新富街道","230904005":"龙湖街道","230904100":"茄子河镇","230904101":"宏伟镇","230904200":"铁山乡","230904201":"中心河乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230904.json
// module id = 713
// module chunks = 0